import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { GlobalVars } from '../../providers/global-vars';
import { ApiCaller } from '../../providers/api-caller';
import {TranslateService} from 'ng2-translate/ng2-translate';


/*
  Generated class for the Technicians page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-technicians',
  templateUrl: 'technicians.html'
})
export class TechniciansPage {

    public technicians: any = [];
    public newTech: any = {};

  constructor(public navCtrl: NavController, public navParams: NavParams, public apiCaller : ApiCaller, 
              public globalVars : GlobalVars, public alertCtrl: AlertController, private translate: TranslateService) {}

  ionViewDidLoad() {
    console.log('ionViewDidLoad TechniciansPage2');
      this.getTechnicians();
  }
    getTechnicians(){ 
        console.log('getTechnicians');
        var requestApp = {};
        (requestApp as any).requestType = 'getTechnicians';
      
        (requestApp as any).request = {};
        (requestApp as any).request.partnerId = this.globalVars.generalVars.partnerId;
        (requestApp as any).request.partnerUserId = this.globalVars.generalVars.partnerUserId;
        
        this.apiCaller.load(requestApp, this.globalVars.msgPleaseWait, true).then(data => {
            if (data && (data as any).result == 200){
                this.technicians = (data as any).technicians;
            }
        });
    }

    addTechnician(){
        this.newTech = {};
        let prompt = this.alertCtrl.create({
          title: 'New technician',
          inputs: [
            {
              name: 'name',
              placeholder: 'Name'
            },
            {
              name: 'phone',
              placeholder: 'Phone number'
            },
          ],
          buttons: [
            {
              text: 'Cancel',
              handler: data => {
                console.log('Cancel clicked');
              }
            },
            {
              text: 'Add',
              handler: data => {
                console.log('Saved clicked:'+JSON.stringify(data));
                  if (!data || !data.name || !data.phone){
                      this.globalVars.showAlert('Missing info','Please enter a name and phone number for this technician');
                      return false;
                  }
                  this.newTech.name = data.name;
                  this.newTech.phoneNumber = data.phone;
                  this.doAddTechnician();
              }
            }
          ]
        });
        prompt.present();
    }
    doAddTechnician(){ 
        console.log('doAddTechnician');
        var requestApp = {};
        (requestApp as any).requestType = 'newTechnician';
      
        (requestApp as any).request = {};
        (requestApp as any).request.partnerId = this.globalVars.generalVars.partnerId;
        (requestApp as any).request.partnerUserId = this.globalVars.generalVars.partnerUserId;
        (requestApp as any).request.countryCode = this.globalVars.ipCountry;
        (requestApp as any).request.phoneNumber = this.newTech.phoneNumber;
        (requestApp as any).request.name = this.newTech.name;
      
        this.apiCaller.load(requestApp, this.globalVars.msgPleaseWait, true).then(data => {
            if (data && (data as any).result == 200){
                this.technicians = (data as any).technicians;
            }
        });
    }    
   doDelete(whichOne){ 
       let confirm = this.alertCtrl.create({
      title: this.translate.instant('Are you sure?'),
      message: this.translate.instant('This will permanently delete this technician.'),
      buttons: [
        {
          text: this.globalVars.msgNo,
          handler: () => {
            return;
          }
        },
        {
          text: this.globalVars.msgYes,
          handler: () => {
            console.log('doDelete');
            var requestApp = {};
            (requestApp as any).requestType = 'deleteTechnician';

            (requestApp as any).request = {};
            (requestApp as any).request.partnerId = this.globalVars.generalVars.partnerId;
            (requestApp as any).request.partnerUserId = this.globalVars.generalVars.partnerUserId;
            (requestApp as any).request.technicianId = whichOne.technician_id;

            this.apiCaller.load(requestApp, this.globalVars.msgPleaseWait, true).then(data => {
                if (data && (data as any).result == 200){
                    this.technicians = (data as any).technicians;
                }
            });
                              return;
              }
            }
          ]
        });
        confirm.present();
    }

}



// WEBPACK FOOTER //
// ./src/pages/technicians/technicians.ts